import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { HashLink as Link } from 'react-router-hash-link';
import PropTypes from 'prop-types';
import { Input } from '@heroui/react';
import { ButtonDiv, ErrorSpan } from './signInSignUp';
import { PlaceHolder } from '../../userDocuments/editDocument/UI/Editor/EditSpace/EditorPane/RenderContent/arrayItems';
import keyCodes from '../../userDocuments/editDocument/editJournal/constants/keyCodes';
import breakpointsMinWidth from '../../../styling/breakpointsMinWidth';
import CustomButton from './components/button';

export const StyledLink = styled.div`
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  a {
    font-size: 14px;
    color: #2584f0;
    padding: 0;
    text-decoration: none;
  }
  ${(props) => {
    const { isPassword } = props;
    if (isPassword) {
      return css`
        text-align: right;
        line-height: 24px;
        height: 24px;
        a {
          font-size: 14px;
          color: #2584f0;
          text-decoration: none;
        }
      `;
    }
    return css``;
  }}
`;

export const SignInButton = styled.div`
  color: #fff;
  background: #473880;
  box-shadow: 1px 1px 4px rgba(71, 56, 128, 0.5);
  border-radius: 4px;
  padding: 12px 24px;
`;
export const InputsWrapper = styled.div`
  margin: 16px 0 0 0;
  position: relative;
  display: flex;
  gap: 16px;
  flex-direction: column;
  @media ${breakpointsMinWidth.tabletMd} {
    margin: 16px 0 0 0;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin: 20px 0 0 0;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin: 24px 0 0 0;
  }
`;
export const PlaceHolderWrapper = styled(PlaceHolder)`
  left: 14px;
  padding: 0;
  @media ${breakpointsMinWidth.mobileMicroLg} {
    padding: 0;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    padding: 0;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 0;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 0;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 0;
    font-size: 14px;
  }

  ${(props) => {
    const { text } = props;
    if (text) {
      return css`
        font-size: 12px;
        line-height: 14px;
        top: 0%;
        background: #ffffff;
        border-radius: 4px;
      `;
    }
    return css``;
  }}
`;
const SignIn = (props) => {
  const {
    handleChange,
    handleLogin,
    email,
    password,
    showLoading,
    errorMessage,
  } = props;

  useEffect(() => {
    const loginOnEnter = (event) => {
      if (event.keyCode === keyCodes.ENTER) {
        event.preventDefault();
        event.stopPropagation();
        handleLogin();
      }
    };
    document.addEventListener('keydown', loginOnEnter, false);
    return () => {
      document.removeEventListener('keydown', loginOnEnter, false);
    };
  });

  return (
    <>
      <InputsWrapper>
        <Input
          type="email"
          label="Email"
          placeholder="Enter your email"
          isRequired
          value={email}
          onChange={(e) => {
            handleChange(e, 'email');
          }}
          data-testid="email-signIn"
        />
        <Input
          type="password"
          label="Password"
          placeholder="Enter your password"
          isRequired
          value={password}
          onChange={(e) => {
            handleChange(e, 'password');
          }}
          data-testid="password-signIn"
        />
      </InputsWrapper>
      {errorMessage && (
        <ErrorSpan className="mt-[4px] flex w-full justify-center">
          {' '}
          {errorMessage}
        </ErrorSpan>
      )}
      <StyledLink className="!h-[50px] tabletSm:!h-[36px] desktopSm:!h-[36px] desktopMd:!h-[50px]">
        <Link to="/forgotPassword" data-testid="forgotPassword">
          {' '}
          Forgot Password{' '}
        </Link>
      </StyledLink>
      <ButtonDiv className="!mb-[4px]">
        <CustomButton
          isLoading={showLoading}
          onClick={handleLogin}
          isDisabled={showLoading || !email || !password}
          data-testid="button-signIn"
          variant="solid"
          color="primary"
        >
          Login
        </CustomButton>
      </ButtonDiv>
    </>
  );
};

SignIn.propTypes = {
  handleChange: PropTypes.func,
  handleLogin: PropTypes.func,
  email: PropTypes.string,
  password: PropTypes.string,
  showLoading: PropTypes.bool,
};

SignIn.defaultProps = {
  handleChange: () => {},
  handleLogin: () => {},
  email: '',
  password: '',
  showLoading: false,
};

export default SignIn;
